module.exports = __webpack_public_path__ + "img/599-42dfb3.png";